module.exports = __webpack_public_path__ + "img/pic2.081696fe.png";